export default `<svg
  width="15"
  height="15"
  viewBox="0 0 15 15"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_2486_357)">
    <path
      d="M0.595238 3.57143V0.595238H1.78571V2.44286C3.12857 0.917857 5.07381 0 7.14286 0C11.0815 0 14.2857 3.20417 14.2857 7.14286H13.0952C13.0952 3.86071 10.425 1.19048 7.14286 1.19048C5.26548 1.19048 3.50298 2.08929 2.38631 3.57143H4.7619V4.7619H1.78571C1.12917 4.7619 0.595238 4.22798 0.595238 3.57143ZM12.5 9.52381H9.52381V10.7143H11.8994C10.7821 12.1964 9.02024 13.0952 7.14286 13.0952C3.86071 13.0952 1.19048 10.425 1.19048 7.14286H0C0 11.0815 3.20417 14.2857 7.14286 14.2857C9.2119 14.2857 11.1571 13.3679 12.5 11.8429V13.6905H13.6905V10.7143C13.6905 10.0577 13.1565 9.52381 12.5 9.52381Z"
      fill="var(--color)"
    />
  </g>
  <defs>
    <clipPath id="clip0_2486_357">
      <rect width="14.2857" height="14.2857" fill="none" />
    </clipPath>
  </defs>
</svg>`;
